import { pxToRemNum } from "./utils/pxToRemNum";

export const theme = {
  colors: {
    imperialRed: "#ED2835",
    linen: "#FDEAEB",
    lightRed: "#FBC9CD",
    begonia: "#F26972",
    white: "#FFFFFF",
    platinum: "#E5E5E5",
    phillipineSilver: "#B5B6B6",
    taupeGrey: "#88898A",
    graniteGrey: "#605E5D",
    onyx: "#353839",
    black: "#000000",
    emerald: "#48C978",
    amber: "#FFBF00",
    firebrick: "#BE202A",
  },
  breakpoints: {
    xs: "screen and (max-width: 399px)",
    sm: "screen and (min-width: 400px) and (max-width: 599px)",
    md: "screen and (min-width: 600px) and (max-width: 899px)",
    lg: "screen and (min-width: 900px) and (max-width: 1199px)",
    xl: "screen and (min-width: 1200px) and (max-width: 1800px)",
  },
  breakpointValues: {
    xs: 400,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1800,
  },
  fontFace: {
    itc_avant_garde_gothicbold: `'itc_avant_garde_gothicbold', Arial, Helvetica, sans-serif`,
    itc_avant_garde_gothicmedium: `'itc_avant_garde_gothicmedium', Arial, Helvetica, sans-serif`,
    maitree: `'Maitree', Times New Roman, Times, serif`,
    caveat: `'Caveat', cursive`,
  },
  fontWeight: {
    hairline: "100",
    thin: "200",
    light: "300",
    normal: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
    extrabold: "800",
    black: "900",
  },
  baseFont: {
    xs: 18,
    sm: 20,
    md: 22,
    lg: 24,
    xl: 26,
  },
  fontBase: 18, // base font in px
  fontScale: {
    majorSecond: {
      size: pxToRemNum(18),
      display: pxToRemNum(36.49),
      heading: pxToRemNum(32.44),
      subheading: pxToRemNum(28.83),
      title: pxToRemNum(25.63),
      subtitle: pxToRemNum(22.78),
      label: pxToRemNum(20.25),
      menu: pxToRemNum(18),
      body: pxToRemNum(18),
      caption: pxToRemNum(16),
      overline: pxToRemNum(16),
      fine: pxToRemNum(14.22),
      button: pxToRemNum(18),
    },
    minorThird: {
      size: pxToRemNum(20),
      display: pxToRemNum(53.75),
      heading: pxToRemNum(44.79),
      subheading: pxToRemNum(37.32),
      title: pxToRemNum(31.1),
      subtitle: pxToRemNum(25.92),
      label: pxToRemNum(21.6),
      menu: pxToRemNum(18),
      body: pxToRemNum(20),
      caption: pxToRemNum(15),
      overline: pxToRemNum(15),
      fine: pxToRemNum(12.5),
      button: pxToRemNum(20),
    },
    majorThird: {
      size: pxToRemNum(22),
      display: pxToRemNum(68.66),
      heading: pxToRemNum(54.93),
      subheading: pxToRemNum(43.95),
      title: pxToRemNum(35.16),
      subtitle: pxToRemNum(28.13),
      label: pxToRemNum(22.5),
      menu: pxToRemNum(18),
      body: pxToRemNum(22),
      caption: pxToRemNum(14.4),
      overline: pxToRemNum(14.4),
      fine: pxToRemNum(11.52),
      button: pxToRemNum(22),
    },
    perfectFourth: {
      size: pxToRemNum(24),
      display: pxToRemNum(100.98),
      heading: pxToRemNum(75.76),
      subheading: pxToRemNum(56.83),
      title: pxToRemNum(42.63),
      subtitle: pxToRemNum(31.98),
      label: pxToRemNum(23.99),
      menu: pxToRemNum(18),
      body: pxToRemNum(24),
      caption: pxToRemNum(13.5),
      overline: pxToRemNum(13.5),
      fine: pxToRemNum(10.13),
      button: pxToRemNum(24),
    },
    augmentedFourth: {
      size: pxToRemNum(26),
      display: pxToRemNum(143.87),
      heading: pxToRemNum(101.75),
      subheading: pxToRemNum(71.96),
      title: pxToRemNum(50.89),
      subtitle: pxToRemNum(35.99),
      label: pxToRemNum(25.45),
      menu: pxToRemNum(18),
      body: pxToRemNum(26),
      caption: pxToRemNum(12.73),
      overline: pxToRemNum(12.73),
      fine: pxToRemNum(9),
      button: pxToRemNum(26),
    },
  },
  lineHeight: {
    display: 0.9,
    heading: 1,
    subheading: 1.1,
    title: 1.2,
    subtitle: 1.3,
    label: 1.4,
    menu: 1,
    body: {
      xs: 1.625,
      sm: 1.675,
      md: 1.7375,
      lg: 1.8,
      xl: 1.875,
    },
    caption: 1.67,
    overline: 1.67,
    fine: 1.67,
    button: 1.5,
  },
  letterSpacing: {
    display: "-0.05em",
    heading: "-0.04em",
    subheading: "-0.03em",
    title: "-0.02em",
    subtitle: "-0.01em",
    label: "0em",
    menu: "0.2em",
    body: "0.01em",
    caption: "0.02em",
    overline: "0.2em",
    fine: "0.03em",
    button: "0em",
  },
  spacing: {
    vertical: {
      xs: pxToRemNum(8),
      sm: pxToRemNum(16),
      md: pxToRemNum(24),
      lg: pxToRemNum(32),
      xl: pxToRemNum(40),
    },
    horizontal: {
      xs: pxToRemNum(8),
      sm: pxToRemNum(16),
      md: pxToRemNum(24),
      lg: pxToRemNum(32),
      xl: pxToRemNum(40),
    },
    hero: {
      xs: pxToRemNum(32),
      sm: pxToRemNum(48),
      md: pxToRemNum(64),
      lg: pxToRemNum(80),
      xl: pxToRemNum(96),
    },
    pageSubtitle: {
      xs: pxToRemNum(8),
      sm: pxToRemNum(12),
      md: pxToRemNum(16),
      lg: pxToRemNum(20),
      xl: pxToRemNum(24),
    },
    sectionTitle: {
      xs: pxToRemNum(16),
      sm: pxToRemNum(20),
      md: pxToRemNum(24),
      lg: pxToRemNum(28),
      xl: pxToRemNum(32),
    },
    section: {
      xs: pxToRemNum(32),
      sm: pxToRemNum(48),
      md: pxToRemNum(64),
      lg: pxToRemNum(80),
      xl: pxToRemNum(96),
    },
    card: {
      xs: pxToRemNum(32),
      sm: pxToRemNum(40),
      md: pxToRemNum(48),
      lg: pxToRemNum(56),
      xl: pxToRemNum(64),
    },
    button: {
      xs: pxToRemNum(16),
      sm: pxToRemNum(24),
      md: pxToRemNum(32),
      lg: pxToRemNum(40),
      xl: pxToRemNum(48),
    },
    element: {
      xs: pxToRemNum(16),
      sm: pxToRemNum(24),
      md: pxToRemNum(32),
      lg: pxToRemNum(40),
      xl: pxToRemNum(48),
    },
    form: {
      xs: pxToRemNum(8),
      sm: pxToRemNum(12),
      md: pxToRemNum(16),
      lg: pxToRemNum(20),
      xl: pxToRemNum(24),
    },
    formField: {
      xs: pxToRemNum(52),
      sm: pxToRemNum(60),
      md: pxToRemNum(68),
      lg: pxToRemNum(76),
      xl: pxToRemNum(84),
    },
    formLabel: {
      xs: pxToRemNum(16),
      sm: pxToRemNum(24),
      md: pxToRemNum(32),
      lg: pxToRemNum(40),
      xl: pxToRemNum(48),
    },
    formGap: {
      xs: pxToRemNum(8),
      sm: pxToRemNum(16),
      md: pxToRemNum(24),
      lg: pxToRemNum(32),
      xl: pxToRemNum(40),
    },
    footer: {
      xs: pxToRemNum(16),
      sm: pxToRemNum(20),
      md: pxToRemNum(24),
      lg: pxToRemNum(28),
      xl: pxToRemNum(32),
    },
    xs: 0.88888889,
    sm: 1.33333333,
    md: 1.77777778,
    lg: 2.22222222,
    xl: 2.66666667,
    // section: 32,
    // card: 16,
    gutter: 16,
  },
};
